import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";
import { useTr } from "@/i18n";

const highlights = [
  { value: "25+", label: "Anni di Esperienza" },
  { value: "1500+", label: "Eventi Realizzati" },
  { value: "100%", label: "Passione & Dedizione" },
];

const gear = [
  "Pioneer DJ Console",
  "Impianto RCF Audio",
  "Fontane Fredde Sparkular",
  "Laser Show",
  "Microfoni Shure Wireless",
  "Karaoke Professionale",
];

export default function About() {
  const tr = useTr();
  const hlLabels = tr("about.highlights", highlights.map((h) => h.label));
  const items = highlights.map((h, i) => ({ ...h, label: hlLabels[i] || h.label }));
  return (
    <section id="esperienza" className="py-24 bg-[#080808]">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow={tr("about.eyebrow", "Chi Sono")}
          title={tr("about.title", "25 Anni di Passione dietro la Console")}
          testid="about-heading"
        />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center px-6">
          <motion.div
            className="gold-frame rounded-2xl overflow-hidden"
            initial={{ opacity: 0, x: -32 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
          >
            <img
              src="/assets/banner.webp"
              srcSet="/assets/banner-768.webp 768w, /assets/banner-1200.webp 1200w, /assets/banner.webp 2000w"
              sizes="(max-width: 1024px) 100vw, 50vw"
              alt="DJ Magix in consolle"
              data-testid="about-image"
              width={2000}
              height={683}
              className="w-full h-64 sm:h-full object-cover"
              loading="lazy"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 32 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
          >
            <p className="font-accent italic text-xl text-[#F7DE8B]">
              {tr("about.quote", "Un quarto di secolo di musica, emozioni e tecnologia.")}
            </p>
            <p className="text-base text-[#E2C882]/85 leading-relaxed mt-5">
              {tr("about.p1", "Da oltre 25 anni DJ Magix accende le piste da ballo della Svizzera e del Nord Italia: dalle feste di paese del Ticino ai club più esclusivi, dai matrimoni da sogno ai grandi eventi aziendali. La sua forza è leggere la pista e creare l'alchimia perfetta tra generazioni e generi diversi.")}
            </p>
            <p className="text-base text-[#E2C882]/85 leading-relaxed mt-4">
              {tr("about.p2", "Come producer realizza remix e custom edits esclusivi: ogni evento ha una colonna sonora che non troverai da nessun'altra parte.")}
            </p>
            <p className="text-base text-[#E2C882]/85 leading-relaxed mt-4">
              {tr("about.p3", "Animatore e ballerino oltre che producer: quando serve scende in pista e trascina anche gli ospiti più timidi. Lavora in ville, castelli, ristoranti e piazze. Conduce ogni evento in italiano, con scaletta e annunci preparati in anticipo — utile quando gli invitati arrivano da mezzo mondo.")}
            </p>

            <div className="grid grid-cols-3 gap-4 mt-8">
              {items.map((h) => (
                <div
                  key={h.label}
                  className="gold-frame rounded-lg bg-[#111111] p-4 text-center"
                >
                  <p className="font-display text-2xl sm:text-3xl font-bold gold-text">
                    {h.value}
                  </p>
                  <p className="text-[10px] uppercase tracking-[0.15em] text-[#BFA45D] mt-1.5">
                    {h.label}
                  </p>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-2.5 mt-8">
              {gear.map((g) => (
                <span
                  key={g}
                  className="rounded-full border border-[rgba(226,184,87,0.3)] bg-black/40 px-3.5 py-1.5 text-xs text-[#E2C882]"
                >
                  {g}
                </span>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
